import React, {useEffect } from 'react'; 
import { Link } from 'react-router-dom'
import Header from "../Component/Header";
const JuniorBoard = () => {
    useEffect(() => {
        document.title = 'Junior Board -  The Air Force School Subroto Park';  
    }, []);  
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li>  About Us</li>
                <li>Prefectorial Board</li>
                 <li>Junior Board</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1> Junior School </h1>
                    </div>
                </div>
                <div className="row">
                <div className="col-lg-12">
                <h6>Student Council 2024-2025</h6>
                <div className="table-responsive maintable">
                <table className="table">
                   <thead>
                          <tr>
                           <th>Designation</th>
                           <th>Name </th>
                           <th>Class/Sec</th>
                         </tr>
                   </thead>
                   <tbody> 
             <tr> <td> HEAD GIRL </td> <td> Akshita Harikrishnan </td> <td> VE </td> </tr> <tr> <td> HEAD BOY </td> <td> Anirudha  Kumar Dubey </td> <td> VC </td> </tr> <tr> <td> VICE HEAD GIRL </td> <td> Arna Chaudhary </td> <td> VB </td> </tr> <tr> <td> VICE HEAD BOY </td> <td> Aaayan Sharma </td> <td> VA </td> </tr> <tr> <td> SPORTS CAPTAIN (GIRLS) </td> <td> Kanishka Singh </td> <td> VC </td> </tr> <tr> <td> GAMES CAPTAIN (BOYS) </td> <td> Purahan Pillai </td> <td> VB </td> </tr> <tr> <td> VICE SPORTS CAPTAIN (GIRLS) </td> <td> Kashu </td> <td> VA </td> </tr> <tr> <td> VICE SPORTS CAPTAIN (BOYS) </td> <td> Arastu Mishra </td> <td> VB </td> </tr>   <tr> <td> DISCIPLINE PREFECT </td> <td> Navya Sajane </td> <td> VA </td> </tr> <tr> <td> </td> <td> Harshit Dagur </td> <td> VB </td> </tr> <tr> <td> </td> <td> Maisha Gera </td> <td> VC </td> </tr> <tr> <td> </td> <td> Abhijay  Pratap Bhargava </td> <td> VD </td> </tr> <tr> <td> </td> <td> Vihaan Boora </td> <td> VE </td> </tr> <tr> <td> CO-CURRICULAR PREFECT </td> <td> Ravya Singh </td> <td> VA </td> </tr> <tr> <td> </td> <td> Gauri Thakur </td> <td> VB </td> </tr> <tr> <td> </td> <td> Shireen Kaur </td> <td> VC </td> </tr> <tr> <td> </td> <td> Adiva Gautam </td> <td> VD </td> </tr> <tr> <td> </td> <td> Sambhavi Singh </td> <td> VE </td> </tr> <tr> <td> ACADEMIC PREFECT </td> <td> Seerat Adgotra </td> <td> VA </td> </tr> <tr> <td> </td> <td> Aarav Sharma </td> <td> VB </td> </tr> <tr> <td> </td> <td> Simrat Kaur </td> <td> VC </td> </tr> <tr> <td> </td> <td> Naina </td> <td> VD </td> </tr> <tr> <td> </td> <td> NaavyaTomar </td> <td> VE </td> </tr> <tr> <td> LITERARY PREFECT </td> <td> Jaanvi Jain </td> <td> VA </td> </tr> <tr> <td> </td> <td> Ijjurouthu Sai Satvik </td> <td> VB </td> </tr> <tr> <td> </td> <td> Siddhi Kathuria </td> <td> VC </td> </tr> <tr> <td> </td> <td> Samagra Joshi </td> <td> VD </td> </tr> <tr> <td> </td> <td> Anika Bisht </td> <td> VE </td> </tr> <tr> <td> ENVIRONMENTAL PREFECT </td> <td> Jiya Thakur </td> <td> VA </td> </tr> <tr> <td> </td> <td> Upashna </td> <td> VB </td> </tr> <tr> <td> </td> <td> Lavnya Singh </td> <td> VC </td> </tr> <tr> <td> </td> <td> Hargun </td> <td> VD </td> </tr> <tr> <td> </td> <td> Harsh Kumar Ray </td> <td> VE </td> </tr>
         </tbody>
        </table>
        </div>
         
                </div>
            </div>
            </div>
        </div>
     </>
  )
}

export default JuniorBoard